module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_HKFEMC.b474db28.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_HKFEMC.png
// module id = 63
// module chunks = 0